// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"12ac4e6b","239":"b429efdb","455":"72787957","977":"24e6d1a4"}[chunkId] + ".chunk.js";
};